/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AsyncEntrypointProps } from './AppSwitcherIntegrationEntrypoint.entrypoint.types.tsx';

type EntryPointParams = {
	isOpen: boolean;
	onClose(): void;
	onOpen(): void;
};

type AppSwitcherIntegrationEntrypointComponent = EntryPointComponent<
	{},
	{},
	AsyncEntrypointProps,
	{}
>;

export const AppSwitcherIntegrationEntrypoint: EntryPoint<
	AppSwitcherIntegrationEntrypointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<AppSwitcherIntegrationEntrypointComponent>(
		/* webpackChunkName: "async-topnav4-app-switcher-entrypoint" */ './async.tsx',
	),
	getPreloadProps: (params: EntryPointParams) => ({ extraProps: params }),
});
